/* ------------------------------------------------------------------
   Cart shipping estimate.

   WHY. 76 of 7,263 sessions reached checkout in the 90 days to 17 Aug and
   only 44 finished — a 42% drop at the last step. Shipping is the prime
   suspect: median shipping is ~18% of order value after the handling-fee cut,
   frequently 40%+, and on freight-weight orders it has run to 94% of the
   goods. Until now the number first appeared at checkout step 3, after the
   buyer had entered their address.

   Measured example: 2 x QueueMaster 550 8.5' = $106 of goods, 44 lbs, quotes
   $81.64 UPS Ground to Los Angeles. That is the surprise this removes.

   Showing it earlier does not change what is charged. It moves the bad news
   from step 3 to the cart, where abandoning is cheaper for everyone and where
   a buyer who needs the goods can still decide to proceed.

   HOW. Shopify's own /cart/shipping_rates.json — no app, no key, no rate
   limit worth worrying about. It returns exactly what checkout would, flat
   freight bands included, so heavy orders reveal the $280-$550 band here.

   ⚠️ province is REQUIRED. Verified: zip + country alone returns 422
   {"province":["Select a state"]}, for Canada too. Hence the state select.
   The endpoint's own error messages are good ("Enter a valid ZIP code for the
   United States") so they are surfaced verbatim rather than reworded.

   Scoped to /cart only. The cart drawer is deliberately left alone — a rate
   lookup needs three fields and a drawer is the wrong place for a form.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var STORE_KEY = 'tcc-ship-est';

  var US = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware',
    'District of Columbia','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas',
    'Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi',
    'Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York',
    'North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island',
    'South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington',
    'West Virginia','Wisconsin','Wyoming'];

  var CA = ['Alberta','British Columbia','Manitoba','New Brunswick','Newfoundland and Labrador',
    'Northwest Territories','Nova Scotia','Nunavut','Ontario','Prince Edward Island','Quebec',
    'Saskatchewan','Yukon'];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function money(v) {
    return '$' + Number(v).toFixed(2);
  }

  function build() {
    if (document.querySelector('.tcc-ship-est')) return;

    // Mount above the checkout button so it is read before the decision.
    var btn = document.querySelector('[name="checkout"], button[type="submit"][form], .cart__checkout');
    if (!btn) return;

    /* This theme's checkout button sits OUTSIDE the cart <form> and binds to it
       via form="cartForm-...", so closest('form') is null and the container is
       the button's own parent. An earlier version anchored on
       btn.closest('div'), which resolved to an ANCESTOR of the container and
       threw NotFoundError on insertBefore - the widget silently never
       appeared. Walk up from the button until we hold a direct child of the
       container, which is correct whether or not the form wraps it. */
    var container = btn.closest('form') || btn.parentElement;
    if (!container) return;
    var anchor = btn;
    while (anchor.parentElement && anchor.parentElement !== container) {
      anchor = anchor.parentElement;
    }
    if (anchor.parentElement !== container) return;

    var box = el('div', 'tcc-ship-est');
    box.appendChild(el('h3', 'tcc-ship-est__title', 'Estimate shipping'));
    box.appendChild(el('p', 'tcc-ship-est__intro',
      'Heavy items ship by freight, so the cost varies a lot by destination. Check it here before you go any further.'));

    var row = el('div', 'tcc-ship-est__row');

    var country = el('select', 'tcc-ship-est__field');
    ['United States', 'Canada'].forEach(function (c) {
      var o = el('option', null, c); o.value = c; country.appendChild(o);
    });

    var province = el('select', 'tcc-ship-est__field');
    function fillProvinces() {
      province.innerHTML = '';
      var list = country.value === 'Canada' ? CA : US;
      var ph = el('option', null, country.value === 'Canada' ? 'Province' : 'State');
      ph.value = ''; province.appendChild(ph);
      list.forEach(function (p) { var o = el('option', null, p); o.value = p; province.appendChild(o); });
    }
    fillProvinces();
    country.addEventListener('change', fillProvinces);

    var zip = el('input', 'tcc-ship-est__field');
    zip.type = 'text';
    zip.autocomplete = 'postal-code';
    zip.placeholder = 'ZIP / Postal code';

    var go = el('button', 'tcc-ship-est__go', 'Get rates');
    go.type = 'button';

    row.appendChild(country); row.appendChild(province); row.appendChild(zip); row.appendChild(go);
    box.appendChild(row);

    var out = el('div', 'tcc-ship-est__out');
    box.appendChild(out);
    box.appendChild(el('p', 'tcc-ship-est__note',
      'Estimate only — the exact figure is confirmed at checkout. Ordering on your own carrier account? Call (800) 516-2115.'));

    container.insertBefore(box, anchor);

    // Repeat buyers should not retype their destination.
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (saved) {
        country.value = saved.country || 'United States';
        fillProvinces();
        province.value = saved.province || '';
        zip.value = saved.zip || '';
      }
    } catch (e) {}

    function lookup() {
      out.innerHTML = '';
      out.appendChild(el('p', 'tcc-ship-est__loading', 'Checking rates…'));

      var q = 'shipping_address[country]=' + encodeURIComponent(country.value) +
              '&shipping_address[province]=' + encodeURIComponent(province.value) +
              '&shipping_address[zip]=' + encodeURIComponent(zip.value.trim());

      fetch('/cart/shipping_rates.json?' + q)
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, body: t }; }); })
        .then(function (res) {
          out.innerHTML = '';
          var data = null;
          try { data = JSON.parse(res.body); } catch (e) {}

          if (!res.ok) {
            // Surface Shopify's own messages - they are specific and correct.
            var msgs = [];
            if (data) Object.keys(data).forEach(function (k) { msgs = msgs.concat(data[k]); });
            out.appendChild(el('p', 'tcc-ship-est__err',
              msgs.length ? msgs.join('. ') + '.' : 'Could not get rates for that address.'));
            return;
          }

          try { localStorage.setItem(STORE_KEY, JSON.stringify({
            country: country.value, province: province.value, zip: zip.value.trim() })); } catch (e) {}

          var rates = (data && data.shipping_rates) || [];
          if (!rates.length) {
            out.appendChild(el('p', 'tcc-ship-est__err',
              'No rates came back for that address. Call (800) 516-2115 and we will quote it.'));
            return;
          }
          var list = el('ul', 'tcc-ship-est__rates');
          rates.forEach(function (r) {
            var li = el('li');
            li.appendChild(el('span', 'tcc-ship-est__rate-name', r.name));
            li.appendChild(el('span', 'tcc-ship-est__rate-price', money(r.price)));
            list.appendChild(li);
          });
          out.appendChild(list);
        })
        .catch(function () {
          out.innerHTML = '';
          out.appendChild(el('p', 'tcc-ship-est__err',
            'Could not reach the rate service. Call (800) 516-2115 and we will quote it.'));
        });
    }

    go.addEventListener('click', lookup);
    zip.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookup(); } });
  }

  function run() {
    if (!/^\/cart\/?$/.test(window.location.pathname)) return;
    // Guarded: the MutationObserver calls this on every cart re-render, so an
    // unexpected DOM shape must not throw on a loop.
    try { build(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // The cart re-renders on quantity change, which can wipe the widget.
  if (window.MutationObserver) {
    new MutationObserver(function () { run(); }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ------------------------------------------------------------------
   Freight note on product pages.

   The flat freight bands start at 149.1 lb of CART weight. Two different
   facts are worth telling a buyer before they add to cart:

   1. 14 products weigh 149.1 lb or more on their own, so they are always
      freight (carts, SkyPro, the big panel kits, RollerSafety Twin 250).
   2. Far more common: a stanchion is 22-26 lb, so SEVEN QueueMaster 550s
      crosses the threshold. Multi-unit stanchion orders are TCC's norm - 26
      of 33 stanchion units in the last 50 orders were one belt length - so
      the quantity at which parcel becomes freight is the useful number.

   Weight comes from /products/<handle>.js (variants[].grams), read per
   SELECTED variant, because variants differ (SkyPro belt lengths especially).

   ⚠️ The threshold applies to the WHOLE cart, not this product alone, so the
   quantity is described as approximate. Saying "7 or more" as though it were
   exact would be wrong the moment anything else is in the basket.

   Suppressed when the unit is light enough that the crossover quantity is
   unrealistic - at 0.98 lb an acrylic insert would need 153, which is noise.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var FREIGHT_LB = 149.1;
  var MAX_UNITS = 12;      // above this, the crossover is not a real scenario
  var GRAMS_PER_LB = 453.592;

  var cache = null;

  function currentVariantId() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return Number(m[1]);
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? Number(input.value) : null;
  }

  function note(text) {
    var box = document.querySelector('.tcc-freight-note');
    if (!box) {
      var anchor = document.querySelector('[class~="#product-qty-selector"]') ||
                   document.querySelector('form[action*="/cart/add"]');
      if (!anchor || !anchor.parentElement) return;
      box = document.createElement('div');
      box.className = 'tcc-freight-note';
      anchor.parentElement.insertBefore(box, anchor);
    }
    box.textContent = text;
  }

  function clear() {
    var box = document.querySelector('.tcc-freight-note');
    if (box && box.parentElement) box.parentElement.removeChild(box);
  }

  function apply(data) {
    var vid = currentVariantId();
    var v = null;
    if (data && data.variants) {
      v = data.variants.filter(function (x) { return x.id === vid; })[0] || data.variants[0];
    }
    /* ⚠️ On a product variant the key is `weight`, NOT `grams`. `grams` is the
       CART line-item key. Reading v.grams here returned undefined on every
       product and the note silently never rendered. Both are checked so this
       survives either shape. */
    var g = (typeof v.weight === 'number' ? v.weight : v.grams);
    if (!g) { clear(); return; }

    var lb = g / GRAMS_PER_LB;
    if (lb >= FREIGHT_LB) {
      note('Ships by freight, not parcel. The cost varies a lot by destination \u2014 ' +
           'check it in your cart before checkout, or call (800) 516-2115 for a quote.');
      return;
    }
    var units = Math.ceil(FREIGHT_LB / lb);
    if (units <= MAX_UNITS) {
      note('Around ' + units + ' or more of these ships by freight rather than parcel, which ' +
           'costs more. Add your quantity and check the cost in your cart \u2014 or call ' +
           '(800) 516-2115 and we will quote it.');
      return;
    }
    clear();
  }

  function run() {
    var m = window.location.pathname.match(/^\/(?:collections\/[^/]+\/)?products\/([^/?#]+)/);
    if (!m) return;
    if (cache && cache.handle === m[1]) { apply(cache.data); return; }
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { cache = { handle: m[1], data: d }; apply(d); })
      .catch(function () {});
  }

  function safeRun() { try { run(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeRun);
  } else {
    safeRun();
  }

  // Variant switches rewrite the URL and/or the hidden id input.
  document.addEventListener('change', safeRun);
  window.addEventListener('popstate', safeRun);
})();
